import { Screen } from '../../components/Screen';

export function Invalida({ motivo }: { motivo: 'no_encontrada' | 'anulada' }) {
  const textos =
    motivo === 'anulada'
      ? {
          h: 'Esta invitación fue cancelada',
          p: 'Ya no es válida para registrarse. Escríbele a la persona que te la compartió para que te envíe una nueva.',
        }
      : {
          h: 'No encontramos esta invitación',
          p: 'La liga está incompleta o mal copiada. Revisa que hayas abierto la liga completa del mensaje, o pídele a quien te invitó que te la reenvíe.',
        };
  return (
    <Screen centrado>
      <div className="space-y-2">
        <h1 className="text-xl font-semibold text-texto">{textos.h}</h1>
        <p className="text-sm text-texto/60">{textos.p}</p>
      </div>
    </Screen>
  );
}
